import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "./Login.css";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [showRoleOptions, setShowRoleOptions] = useState(true);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      // Call AuthContext login (async, hits backend now)
      const result = await login(username, password);

      if (result.success) {
        // Redirect based on role
        const roleRoutes = {
          admin: "/admin",
          accounts: "/accounts",
          officer: "/officer",
        };

        navigate(roleRoutes[result.role] || "/");
      } else {
        setError("❌ Invalid credentials! Please try again.");
      }
    } catch (err) {
      setError("❌ Login failed. Please try again.");
      console.error("Login error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  // Role selection handler - just shows welcome message, doesn't pre-fill credentials
  const handleRoleSelection = (role) => {
    setSelectedRole(role);
    setShowRoleOptions(false); // Hide role buttons immediately
    
    // Clear any existing form data
    setUsername("");
    setPassword("");
    setError("");

    // Show welcome message for 2 seconds then show login form
    setTimeout(() => {
      setSelectedRole(null); // Clear welcome message to show login form
    }, 2000);
  };

  // Role display names
  const roleNames = {
    admin: "Admin",
    accounts: "Accountant",
    officer: "Officer",
    resident: "Resident",
  };

  return (
    <div className="login-container">
      <div className={`login-box ${selectedRole ? "compact" : ""}`}>
        {/* Welcome Screen */}
        {selectedRole && (
          <div className="welcome-screen">
            <div className="welcome-spinner"></div>
            <h2>Welcome {roleNames[selectedRole]}</h2>
            <p>Please enter your credentials to continue...</p>
          </div>
        )}

        {!selectedRole && (
          <>
            <div className="login-header">
              <div className="police-logo"></div>
              <h2>Polie Lines Residential Portal- Kanpur</h2>
              <p>Secure Login Portal</p>
            </div>

            {error && (
              <div className="status-message status-error">{error}</div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <label>Username</label>
                <input
                  type="text"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  disabled={isLoading}
                  autoComplete="off"
                />
              </div>

              <div className="input-group">
                <label>Password</label>
                <input
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={isLoading}
                  autoComplete="off"
                />
              </div>

              <button
                type="submit"
                className={`login-btn ${isLoading ? "loading" : ""}`}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner"></span>
                    Logging in...
                  </>
                ) : (
                  "Login"
                )}
              </button>

              <div className="additional-options">
                <label className="remember-me">
                  <input type="checkbox" /> Remember me
                </label>

                <a href="#forgot" className="forgot-password">
                  Forgot Password?
                </a>
              </div>
            </form>

            {showRoleOptions && (
              <div className="demo-section">
                <h4>Select your role</h4>
                <div className="demo-buttons">
                  <button
                    className="demo-btn admin"
                    onClick={() => handleRoleSelection("admin")}
                    disabled={isLoading}
                  >
                    Admin Login
                  </button>
                  <button
                    className="demo-btn accounts"
                    onClick={() => handleRoleSelection("accounts")}
                    disabled={isLoading}
                  >
                    Accountant Login
                  </button>
                  <button
                    className="demo-btn officer"
                    onClick={() => handleRoleSelection("officer")}
                    disabled={isLoading}
                  >
                    Officer Login
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Login;

